// docs: https://github.com/altostra/type-validations#readme
import { objectOf } from "@altostra/type-validations";
import { isTrackingDomain } from "@dashboardApi/apis/companiesCompanyIdEmailSelfServeConfigurationData";

export const isPostAssignExistingTrackingDomainResult = objectOf({
  trackingDomain: isTrackingDomain,
});
